import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect, useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip, TextField } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import DetentionMultiLineBarChart from "../DetentionMultiLineBarChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormControl, InputLabel } from "@material-ui/core";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    marginBottom: "10px",
  },
  paper: {
    boxShadow:
      "5px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10) !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    // padding: "0px 10px",
  },
  // appBar: {
  //   padding: "10px",
  // },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
}));

const GraphViewDetention = ({
  KPILoading,
  tabIndex,
  Module,
  Network,
  Temperature,
  FacilityType,
  Facility,
  location,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  dateRangeDetention,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    tabValue === 2 ? "State" : "Weekly",
  );
  //const [selectedRadioForFacilityTypeLocationShare, setSelectedRadioForFacilityTypeLocationShare] = useState("State")
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const [benchmarkValue, setBenchMarkValue] = useState(7);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList?.filter(
    (item) => item?.index === tabValue,
  )[0]?.value;
  const [typeValue, setTypeValue] = useState("DELV");

  const radioOptions = {
    0: [
      { displayName: "By Week", id: "Weekly", shouldDisplay: true },
      { displayName: "By Month", id: "Monthly", shouldDisplay: true },
    ],
    1: [
      { displayName: "By Week", id: "Weekly", shouldDisplay: true },
      { displayName: "By Month", id: "Monthly", shouldDisplay: true },
    ],
    // 2: [
    //   { displayName: "By Week", id: "Weekly", shouldDisplay: false },
    //   { displayName: "By Month", id: "Monthly", shouldDisplay: false },
    // ],
    2: [
      { displayName: "State", id: "State", shouldDisplay: true },
      { displayName: "City", id: "City", shouldDisplay: true },
    ],
  };
  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data?.data ? data?.data?.data : data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  // const referenceDate = new Date(dateRangeDetention?.[0]);
  // referenceDate.setDate(referenceDate.getDate() - 30);
  // const startDate = referenceDate.toISOString().split("T")[0];

  const memoizedParams = useMemo(() => {
    return {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis: selectedRadioValue,
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        Temperature: Temperature,
        FacilityType: FacilityType,
        Spend_Location_Type: location,
        Facility: Facility,
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: dateRangeDetention?.[0],
        endDate: dateRangeDetention?.[1],
        deliveryCondition: [typeValue],
      },
    };
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    Temperature,
    FacilityType,
    location,
    Facility,
    PL3,
    Division,
    Products,
    dateRangeDetention,
    activeTab,
    //startDate,
    typeValue,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    if (!KPILoading) {
      getGraphData(memoizedParams);
    }
  }, [memoizedParams, applyFilter]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue(radioOptions[newValue]?.[0]?.id);
    setTopOrBottomValue("Top");
    setCountValue("5");
  };
  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const renderChart = () => {
    if (
      [
        "IncidentRateTrend",
        "DetentionSpendTrend",
        "DetentionReasonsCodes",
        "FacilityTypeLocationShare",
      ].includes(activeTab)
    ) {
      return (
        <DetentionMultiLineBarChart
          graphData={graphData}
          showAnnotation={false}
          activeTab={activeTab}
          benchmarkValue={benchmarkValue}
        />
      );
    }
  };

  const handleTypeChange = (event) => {
    setTypeValue(event.target.value);
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };

  const handleBenchmark = (event, _id) => {
    const { value } = event.target;
    setBenchMarkValue(value);
  };

  const RenderTypeDropdown = () => {
    return (
      <div style={{ flexDirection: "column" }}>
        <InputLabel
          id="type-label"
          style={{
            fontSize: "11px",
            marginBottom: "5px",
            fontWeight: "500",
            color: "#aaaaaaff",
          }}
        >
          {" "}
          Type
        </InputLabel>
        <Select
          labelId="type-label"
          value={typeValue}
          sx={{
            width: "100px",
            "& .MuiInputBase-input": {
              height: "15px",
              borderRadius: "20px",
              fontSize: "13px",
              borderColor: "transparent",
              padding: "4.5px 14px 7px",
            },
          }}
          onChange={handleTypeChange}
        >
          <MenuItem value="DELV">Delivery</MenuItem>
          <MenuItem value="SUPL">Supply</MenuItem>
        </Select>
      </div>
    );
  };

  const getTooltipTitle = (item) => {
    // console.log("item: ", item);
    switch (item) {
      case "IncidentRateTrend":
        return `Bars - # of shipment detention incidents by week/month this year vs same time last year. 
                    Lines- Shipments detained as a % of total shipments for the week/month this year and same time last year
                    From Detention spend optimization output
                    Filters applicable: Spend location type, Facility Type, Facility, Date`;

      case "DetentionSpendTrend":
        return `Bars - $ spent on detention by week/month this year and same time last year. 
                    Lines- Detention spend % of total transportation spend for the week/month this year and same time last year
                    From Detention spend optimization output
                    Filters applicable: Spend location type, Facility Type, Facility, Date`;

      case "DetentionReasonsCodes":
        return `Detention spend by reason codes at a Nestle DC/customer location for the selected time period
                    From Detention spend optimization output
                    Filters applicable: Spend location type, Facility Type, Facility, Date`;

      case "FacilityTypeLocationShare":
        return `Detention spend by city/state for the selected time period
                    From Detention spend optimization output
                    Filters applicable: Spend location type, Facility Type, Facility, Date`;

      default:
        return "This is additional information about the KPI";
    }
  };

  return (
    <>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {graphViewTabList.map((_item, index) => (
            <TabPanel
              key={index}
              value={tabIndex}
              index={index}
              style={{ height: "fit-content" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent={"space-between"}
                style={{ padding: "0px !important" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {[
                      "DetentionReasonsCodes",
                      "FacilityTypeLocationShare",
                    ].includes(activeTab) && (
                      <>
                        <Select
                          value={topOrBottomValue}
                          onChange={handleTopBottomChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          <MenuItem value="Top">Top</MenuItem>
                          <MenuItem value={"Bottom"}>Bottom</MenuItem>
                        </Select>
                        <Select
                          value={countValue}
                          onChange={handleCountChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                    {radioOptions[tabValue] &&
                      radioOptions[tabValue]?.map((item) => {
                        if (!item?.shouldDisplay) {
                          return null;
                        }
                        let id = item?.id;
                        let displayName = item?.displayName;
                        return (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Radio
                              value={id}
                              checked={selectedRadioValue === id}
                              onChange={() => handleRadioChange(id)}
                              size="small"
                              inputProps={{ "aria-label": id }}
                              sx={{
                                color: "#359DD0 !important",
                                "&.Mui-checked": {
                                  color: "#359DD0 !important",
                                },
                              }}
                            />
                            <span
                              className={classes.filter}
                              style={{
                                display: "flex", // Ensures the text and icon are on the same line
                                alignItems: "center", // Vertically aligns the text and icon
                                color:
                                  selectedRadioValue === id
                                    ? "#359DD0"
                                    : "#359DD0",
                              }}
                            >
                              {displayName}
                            </span>
                          </div>
                        );
                      })}
                    <Tooltip
                      title={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getTooltipTitle(activeTab),
                          }}
                        />
                      }
                      placement="top"
                      arrow
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        style={{
                          color: "blue",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                        aria-label="More information"
                      />
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "14px",
                    }}
                  >
                    {[
                      "IncidentRateTrend",
                      "DetentionSpendTrend",
                      "DetentionReasonsCodes",
                      "FacilityTypeLocationShare",
                    ].includes(activeTab) && <RenderTypeDropdown />}
                    {["IncidentRateTrend", "DetentionSpendTrend"].includes(
                      activeTab,
                    ) && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "15px",
                        }}
                      >
                        <InputLabel
                          className={classes.dropDownLabel}
                          style={{
                            fontSize: "11px",
                            marginBottom: "4px",
                            fontWeight: "500",
                            color: "#aaaaaaff",
                          }}
                        >
                          Edit Benchmark{" "}
                        </InputLabel>
                        <TextField
                          size="small"
                          sx={{
                            width: "100px",
                            "& .MuiInputBase-input": {
                              height: "15px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              borderColor: "transparent",
                              // textAlign: "center",
                            },
                          }}
                          // label={"Edit Benchmark"}
                          name="editBenchmark"
                          value={benchmarkValue}
                          onChange={(event) => handleBenchmark(event, index)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </>
  );
};

GraphViewDetention.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  Temperature: state.filter.Temperature,
  FacilityType: state.filter.facType,
  location: state.filter.location,
  Facility: state.filter.facId,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  dateRangeDetention: state.filter.dateRangeDetention,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
  DateRangeFilterDetentionActions: (newValue) =>
    dispatch({ type: "SET_DETENTION_DATERANGE", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewDetention);
